import { NetworkService } from '../../../../services/networkService';
import { mapQueryParams } from '../../../../utility/utility';
import { listingDetailMapper } from '../listings/listingsApis';

export const getLeadListings = async (leadId, filtersList, params) => {
  const mappedParams = mapQueryParams(params, filtersList);
  const response = await NetworkService.get(`/api/lms/leads/${leadId}/listings?${mappedParams}`);
  if (response?.error) {
    return response;
  } else {
    return response?.data?.listings?.map((item) => listingDetailMapper(item));
  }
};
